import { oneOf } from 'prop-types'

export const buttonTypes = oneOf(['submit', 'button', 'reset'])
